
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
outline-icon.active {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.accordion-button {
  margin-left: 0.25rem;
  cursor: pointer;
  background-color: var(--neutral-transparent);
}

.accordion-button.clean {
  padding-left: 0px;
}

.accordion-button.mobile{
  padding:0 0 0 0 !important;
}

.accordion-content {
  margin-left: 0.5rem;
  padding-top: 0px;
  padding-bottom: 0px;
}

.accordion-button.inactive, .accordion-button.active, .accordion-button.clean, .accordion-button.clean.active, .accordion-icon.active, .accordion-icon.inactive, .accordion-icon.clean.inactive {
  background-color: var(--neutral-transparent) !important;
}

.accordion-button.clean {
  border-bottom-width: 1px;
  border-style: solid;
  border-color: var(--blue-responsible-lighten-4);
  padding-left: 0px;
}

.accordion-panel.variant--cards {
  margin: 0px;
  margin-bottom: 1px;
  overflow: visible;
  border-radius: 0px;
}

.accordion-panel.variant--cards .accordion-heading {
  background-color: var(--neutral-white);
}

.accordion-panel.variant--cards .accordion-button {
  margin: 0px;
}

.accordion-panel.variant--cards .accordion-button {
  border-width: 0px;
}

.accordion-panel.variant--cards .accordion-button {
  padding-left: 1rem !important;
}

.accordion-panel.variant--cards .accordion-button {
  color: var(--gray-professional-main);
}

.accordion-panel.variant--cards .accordion-content {
  margin: 0px;
}

.accordion-panel.variant--cards .accordion-content {
  margin-top: 1px;
}

.accordion-panel.variant--cards .accordion-content {
  background-color: var(--neutral-white);
}

.accordion-panel.variant--cards.first .accordion-heading, .accordion-panel.variant--cards.single .accordion-heading {
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}

.accordion-panel.variant--cards.single:not(.active) .accordion-heading, .accordion-panel.variant--cards.last:not(.active) .accordion-heading {
  border-bottom-right-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}

.accordion-panel.variant--detail-list {
  margin-bottom: 1.25rem;
  border-radius: 0.5rem;
  box-shadow:0px 4px 14px 0px rgba(0, 0, 0, 0.1);
}

.accordion-panel.variant--detail-list .accordion-heading {
  background-color: var(--neutral-white);
}

.accordion-panel.variant--detail-list .accordion-label{
    max-width:85%;
  }

.accordion-panel.variant--detail-list .accordion-button {
  margin: 0px;
}

.accordion-panel.variant--detail-list .accordion-button {
  border-width: 0px;
}

.accordion-panel.variant--detail-list .accordion-button {
  padding-left: 1rem !important;
}

.accordion-panel.variant--detail-list .accordion-button {
  padding-top: 1rem !important;
}

.accordion-panel.variant--detail-list .accordion-button {
  padding-bottom: 1.5rem !important;
}

.accordion-panel.variant--detail-list .accordion-button, .accordion-panel.variant--detail-list .accordion-button.clean.active {
  color: var(--blue-responsible-main) !important;
}

.accordion-panel.variant--detail-list .accordion-button.clean.active {
  padding-bottom: 0px !important;
}

.accordion-panel.variant--detail-list .accordion-icon {
  width: 3rem;
}

.accordion-panel.variant--detail-list .accordion-icon {
  align-items: flex-start;
}

.accordion-panel.variant--detail-list .accordion-content {
  margin: 0px;
}

.accordion-panel.variant--detail-list .accordion-content {
  background-color: var(--neutral-white);
}

.accordion-panel.variant--detail-list .accordion-content {
  padding-bottom: 1.5rem;
}
`;